import { useState, useRef } from "react"
import { authorize } from '../../../../server/requests'

export default function Authorize({
    amount,
    setNotValid,
    refAmount,
    setValue,
    setErrorMessage,
    errorMessage
}) {

    const refcardNumber = useRef(null)
    const refname = useRef(null)
    const refsurname = useRef(null)
    const refcardExpirationDate = useRef(null)
    const refcardSvv = useRef(null)

    const [formData, setFormData] = useState({
        cardNumber: '',
        name: '',
        surname: '',
        cardExpirationDate: '',
        cardSvv: ''
    })

    const handleChange = (e) => {

        const { name, value } = e.target

        if (value.length > e.target.getAttribute('max')) return

        if (e.target.getAttribute('valid') == 'numberdate') {

            if (!isNaN(value) || value[value.length - 1] == '/') {
                setFormData({ ...formData, [name]: value })
            }

        } else if (e.target.getAttribute('valid') == 'number') {

            if (!isNaN(value)) setFormData({ ...formData, [name]: value })

        } else {
            setFormData({ ...formData, [name]: value })
        }

    }

    const onSubmit = () => {

        let body = formData
        body.amount = amount

        if (amount == '') {
            refAmount.current.focus()
            setNotValid(true)
        } else if (formData.cardNumber.trim() == '' || formData.cardNumber.trim().length < refcardNumber.current.getAttribute('max')) {
            refcardNumber.current.focus()
        } else if (formData.name.trim() == '') {
            refname.current.focus()
        } else if (formData.surname.trim() == '') {
            refsurname.current.focus()
        } else if (formData.cardExpirationDate.trim() == '' || formData.cardExpirationDate.trim().length < refcardExpirationDate.current.getAttribute('max')) {
            refcardExpirationDate.current.focus()
        } else if (formData.cardSvv.trim() == '' || formData.cardSvv.trim().length < refcardSvv.current.getAttribute('max')) {
            refcardSvv.current.focus()
        } else {

            body.cardExpirationDate = body.cardExpirationDate.replace('/', '')

            authorize(body, res => {

                let obj = {
                    cardNumber: '',
                    name: '',
                    surname: '',
                    cardExpirationDate: '',
                    cardSvv: ''
                }

                setFormData(obj)
                setValue('')

                setErrorMessage({
                    show: true,
                    text: 'Successfully added balance',
                    type: 'success'
                })

                setTimeout(() => {

                    setErrorMessage({
                        ...errorMessage,
                        show: false,
                    })

                }, 3000);

            }, err => {

                console.log(err, 'err')

            })
        }
    }

    return (
        <div className="main_authorize">
            <input type="text" ref={refcardNumber} max={16} onChange={handleChange} valid={'number'} name={'cardNumber'} value={formData.cardNumber} placeholder={'Card number'} />
            <input type="text" ref={refname} max={64} onChange={handleChange} name={'name'} value={formData.name} placeholder={'Name'} />
            <input type="text" ref={refsurname} max={64} onChange={handleChange} name={'surname'} value={formData.surname} placeholder={'Surname'} />
            <div className="date_svv">
                <input type="text" ref={refcardExpirationDate} max={5} onChange={handleChange} valid={''} name={'cardExpirationDate'} value={formData.cardExpirationDate} placeholder={'MM/YY'} />
                <input type="text" ref={refcardSvv} max={3} onChange={handleChange} valid={'number'} name={'cardSvv'} value={formData.cardSvv} placeholder={'SVV'} />
            </div>
            <button onClick={onSubmit}>ADD</button>
        </div>
    )
}